// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScopeAuthorityOutlinedSvg from "@fishx/icons-svg/es/asn/ScopeAuthorityOutlined";
import FishxIcon from '../components/FishxIcon';

var ScopeAuthorityOutlined = function ScopeAuthorityOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScopeAuthorityOutlinedSvg
  }));
};

ScopeAuthorityOutlined.displayName = 'ScopeAuthorityOutlined';
export default React.forwardRef(ScopeAuthorityOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ScopeAuthorityOutlined.js
// module id = 4076
// module chunks = 0